import { render, staticRenderFns } from "./ProtopieIcon.vue?vue&type=template&id=1763e41b&"
import script from "./ProtopieIcon.vue?vue&type=script&lang=js&"
export * from "./ProtopieIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports